define('view/controller/booking/datetime/event/TimeEventItemView',['require','lib/view/LayoutView','lib/Utils'],function (require) {

	var LayoutView = require('lib/view/LayoutView');
    var Utils = require('lib/Utils');
	
	/**
	 * Time Event item view (time slot item)
	 * 
	 * @class TimeEventItemView
	 */
	return LayoutView.extend({
	
	    template: '#time_event_item_view',
        
        events: _.extend({
            'click': 'onChildviewSelectDate',
        }, Utils.ifParams(!Utils.isIos(), {
            'mouseenter': 'onChildviewHoverDate'
        })),

        modelEvents: {
            'change': 'render'
        },

        calendarData : null,

        initialize: function () {
	        var instance = this;
            this._bookingModel = this.getOption('bookingModel');
        },

        serializeData : function () {
            var res = LayoutView.prototype.serializeData.apply(this);
            this.calendarData = this.getOption('calendarData');

            if(this.calendarData && this.calendarData.first_day && this.model.get('date')){
                var startDate = Date.parseMysqlDate(this.calendarData.first_day);
                var currentDate = Date.parseMysqlDate(this.model.get('date'));
                res['show_month'] = startDate.getMonth() != currentDate.getMonth();
            }
            return res;
        },


        onChildviewHoverDate: function (view, data) {
            if (!this.model.get('is_day_off')) {
                this.triggerMethod('hover:date', this.model);
            }
        },

        onChildviewSelectDate: function (view, data) {
            if (!this.model.get('is_day_off')) {
                this.triggerMethod('select:date', this.model);
            }
        }
	    
	});
	
});
